import React from 'react';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const tableStyles = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 15,
    marginBottom: 15,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '33%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
  },
  tableCol: {
    width: '33%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
    textAlign: 'center',
  },
  tallCell: {
    height: 60, // Adjust height as needed
    justifyContent: 'center',
  },
});

const Certificate = ({result}) => (
  <View size="A4" style={style.page}>
    {/* Header */}
    <View>
      <Text style={[style.title, style.ArialBold, {fontSize: 12}]}>
        Pension Scheme for the Teaching Staff in Non-Government Secondary Schools
      </Text>
      <Text style={[style.title, style.ArialBold, {fontSize: 12}]}>
        (vide G.R.E. & S.W.D.NO. SSN3365-G, dated 4th November 1968)
      </Text>
    </View>

    <View style={style.solidLine}/>

    <Text style={[style.title, style.ArialBlack, {marginBottom: 30}]}>Certificate</Text>

    {/* Main Content */}
    <View style={[style.paragraph, {fontSize:10}]}>
      <Text>The pay of {result.employeeName}, {result.designation}, {result.institutionName}, as shown in the service Book and the History of Service, is according to the scale of pay sanctioned by the Government from time to time.</Text>
    </View>

    <View style={[style.paragraph, {marginTop: 20}]}>
      <Text>Place: {result.placeOfRetirement}</Text>
      <Text>Date:</Text>
    </View>
    <Text style={style.signature}>Head of Office</Text>

    <Text style={style.paragraph}>Countersigned by:</Text>
    <Text style={style.paragraph}>Education Officer, Zilla Parishad, {result.educationOfficer}</Text>

    {/* Subject */}
    <View style={[style.paragraph, {marginTop: 10}]}>
      <Text>Statement showing the sources of pay drawn by {result.employeeName}, {result.designation}, {result.institutionName}</Text>
    </View>

    {/* Table */}
    <View style={tableStyles.table}>
      {/* Header Row */}
      <View style={tableStyles.tableRow}>
        <View style={tableStyles.tableColHeader}>
          <Text style={tableStyles.tableCellHeader}>Date of Beginning</Text>
        </View>
        <View style={tableStyles.tableColHeader}>
          <Text style={tableStyles.tableCellHeader}>Date of Ending</Text>
        </View>
        <View style={tableStyles.tableColHeader}>
          <Text style={tableStyles.tableCellHeader}>Paid from what fund</Text>
        </View>
      </View>
      
      {/* Data Row - Single tall row as requested */}
      <View style={tableStyles.tableRow}>
        <View style={[tableStyles.tableCol, tableStyles.tallCell]}>
          <Text style={tableStyles.tableCell}>{result.dateOfAppointment || '________'}</Text>
        </View>
        <View style={[tableStyles.tableCol, tableStyles.tallCell]}>
          <Text style={tableStyles.tableCell}>{result.dateOfRetirement || '________'}</Text>
        </View>
        <View style={[tableStyles.tableCol, tableStyles.tallCell]}>
          <Text style={tableStyles.tableCell}>Govt. Grant in aid</Text>
        </View>
      </View>
    </View>

    <Text style={[style.signature, {marginTop: 50}]}>Head of Office</Text>

    {/* Routing */}
    <View style={style.paragraph}>
      <Text>Countersigned by:</Text>
      <Text style={{marginLeft: 5}}>Education Officer, {result.educationOfficer}</Text>
      <Text style={{marginLeft: 5}}>Zilla Parishad, {result.educationOfficer}</Text>
    </View>
  </View>
);

export default Certificate;